export default "__VITE_ASSET__Dk1JWEpw__"